import Cookies from 'js-cookie'

export class C7AccountLink extends HTMLElement {
  private linkElement: HTMLAnchorElement
  private customerName: string | undefined

  static readonly PROFILE_LINKS = [
    {
      title: 'Club Memberships',
      url: '/profile/club-membership',
    },
    {
      title: 'Order History',
      url: '/profile/order-history',
    },
    {
      title: 'Account Settings',
      url: '/profile/account',
    },
  ]

  constructor() {
    super()

    // Create the link element
    this.linkElement = document.createElement('a')
    this.linkElement.href = '/profile/login'
    this.linkElement.innerText = this.textContent || 'Account Login'

    this.customerName = undefined

    // Append link element
    this.replaceChildren(this.linkElement)
  }

  connectedCallback() {
    this.updateLinkState()

    this.listenForLogin(() => {
      this.updateLinkState(true)
    })
  }

  private setCustomerName(
    firstName: string | undefined,
    lastName: string | undefined,
  ) {
    if (firstName || lastName) {
      this.customerName = `${firstName} ${lastName}`
    }
  }

  private async updateLinkState(delay = false) {
    if (delay) {
      setTimeout(() => {
        this.updateLinkState()
      }, 1000)
      return
    }

    const cookie = Cookies.get('customerToken')
    const script = document.querySelector('#c7-javascript')
    const tenant = script?.getAttribute('data-tenant')

    if (cookie && tenant) {
      try {
        const response = await fetch(
          'https://api.commerce7.com/v1/customer/self',
          {
            headers: {
              Authorization: cookie,
              tenant: tenant,
            },
          },
        )

        if (response.ok) {
          await response.json().then((customer: any) => {
            this.setCustomerName(customer.firstName, customer.lastName)
          })

          this.setLogoutState()
        } else {
          this.setLoginState()
        }
      } catch (error) {
        console.error('Error checking auth status:', error)
        this.setLoginState()
      }
    } else {
      this.setLoginState()
    }
  }

  private setLoginState() {
    this.customerName = undefined
    this.linkElement.textContent = this.textContent || 'Account Login'
    this.linkElement.href = '/profile/login'
  }

  private setLogoutState() {
    // for (const link of C7AccountLink.PROFILE_LINKS) {
    //   const linkElement = document.createElement('a')
    //   linkElement.href = link.url
    //   linkElement.innerText = link.title
    //   linkElement.style.display = 'block'

    //   this.prepend(linkElement)
    // }

    let profileLink = document.createElement('a')
    profileLink.href = '/profile'
    profileLink.innerText = this.customerName || 'My Account'
    profileLink.style.display = 'block'

    // this.appendChild(profileLink)
    this.prepend(profileLink)

    this.linkElement.textContent = 'Logout'
    this.linkElement.href = '/profile/logout'
  }

  private listenForLogin(callback: () => void) {
    console.log('KD: Setting up Fetch and XHR interception...')
    const urlSegmentTarget = 'login'
    const originalOpen = XMLHttpRequest.prototype.open
    const originalSend = XMLHttpRequest.prototype.send

    XMLHttpRequest.prototype.open = function (
      method: string,
      url: string,
      async?: boolean,
      username?: string | null,
      password?: string | null,
    ): void {
      // @ts-ignore-start
      this._url = url
      // @ts-ignore
      this._method = method
      // @ts-ignore
      originalOpen.call(this, method, url, async, username, password)
    }

    XMLHttpRequest.prototype.send = function (
      body?: Document | XMLHttpRequestBodyInit | null | undefined,
    ): void {
      this.addEventListener('loadstart', () => {
        const url = (this as any)._url
        if (typeof url === 'string' && url.includes(urlSegmentTarget)) {
          // console.log(`XHR started: ${url}`)
          callback()
        }
      })

      originalSend.call(this, body)
    }

    const originalFetch = window.fetch

    window.fetch = function (
      input: URL | RequestInfo,
      init?: RequestInit,
    ): Promise<Response> {
      // @ts-ignore
      const url = typeof input === 'string' ? input : input.url

      if (url.includes(urlSegmentTarget)) {
        // console.log(`Fetch started: ${url}`)
        callback()
      }

      return originalFetch.call(this, input, init)
    }
  }
}

// Register the custom element
customElements.define('c7-account-link', C7AccountLink)
